// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Popover from "../../resources/overlays/Popover.res.js";
import * as OpeningButton from "../../resources/actions/OpeningButton.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ProductPriceTableCell from "../Product/ProductPriceTableCell.res.js";
import * as CartProductDiscountPopover from "./CartProductDiscountPopover.res.js";

function CartProductDiscountsTableCell(props) {
  let product = props.product;
  let __editable = props.editable;
  let editable = __editable !== undefined ? __editable : false;
  let match = Popover.useTrigger(undefined, undefined, undefined);
  let popoverTriggerRef = match.ref;
  let popoverAriaProps = match.ariaProps;
  let popover = match.state;
  let formattedTotalLocalDiscounts;
  let exit = 0;
  let totalLocalDiscounts;
  if (product.TAG === "Unit") {
    totalLocalDiscounts = product._0.totalLocalDiscounts;
    exit = 1;
  } else {
    totalLocalDiscounts = product._0.totalLocalDiscounts;
    exit = 1;
  }
  if (exit === 1) {
    formattedTotalLocalDiscounts = Stdlib_Option.map(totalLocalDiscounts, value => I18n.currencyFormat(undefined, "EUR", 3, 3, value.toNumber()));
  }
  let totalAmountElement = JsxRuntime.jsx(ProductPriceTableCell.make, {
    value: formattedTotalLocalDiscounts
  });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      editable ? JsxRuntime.jsx(OpeningButton.make, {
          children: totalAmountElement,
          ariaProps: popoverAriaProps.triggerProps,
          opened: popover.isOpen,
          onPress: param => popover.toggle(),
          ref: popoverTriggerRef
        }) : totalAmountElement,
      popover.isOpen ? JsxRuntime.jsx(CartProductDiscountPopover.make, {
          product: product,
          popover: popover,
          popoverAriaProps: popoverAriaProps,
          popoverTriggerRef: popoverTriggerRef,
          onRequestDispatch: props.onRequestDispatch
        }) : null
    ]
  });
}

let make = React.memo(CartProductDiscountsTableCell, (oldProps, newProps) => {
  if (oldProps.product === newProps.product) {
    return oldProps.editable === newProps.editable;
  } else {
    return false;
  }
});

export {
  make,
}
/* make Not a pure module */
